import * as Yup from 'yup'

const cnic_validator = {
  name: 'is-valid',
  skipAbsent: true,
  test(value, ctx) {
    // if (value === '_____-_______-_') return ctx.createError({message: 'CNIC is required'})
    if (/\d/.test(value) && value.includes('_')) return ctx.createError({message: 'Invalid CNIC'})
    return true
  },
}

const userCommonSchema = {
  name: Yup.string().required('Name is required'),
  father_name: Yup.string(), //.required('Father name is required'),
  father_name: Yup.string(), //.required('Father name is required'),
  email: Yup.string().email('Wrong email format').required('Email is required'),
  phone: Yup.string().required('Phone is required'), //.required('Phone is required'),
  cnic: Yup.string().test(cnic_validator).required('Cnic is required'), //.required('CNIC is required'),
  gender: Yup.string().required('Gender is required'), //.required('Gender is required'),
  dob: Yup.date()
    .nullable()
    .required('DOB is required')
    .max(new Date(), 'DOB cannot be in the future'),

  current_address: Yup.string().required('Current address is required'),
  permanent_address: Yup.string().required('Permanent address is required'),
  home_phone: Yup.string().required('Home phone is required'),
  office_phone: Yup.string().required('Office phone is required'),
  image: Yup.string().required('Image is required'),
}

// AUTH
export const loginSchema = Yup.object({
  email: Yup.string().email('Wrong email format').required('Email is required'),
  password: Yup.string().required('Password is required'),
  // society_id: Yup.string(),
})
export const forgotPasswordSchema = Yup.object({
  email: Yup.string().email('Wrong email format').required('Email is required'),
})
export const registrationSchema = Yup.object({
  ...userCommonSchema,
  password: Yup.string().required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Confirm Password is required'),
  acceptTerms: Yup.bool().oneOf([true], 'You must accept the terms and conditions'),
})
export const verifyOTPSchema = Yup.object({
  otp: Yup.string().required('OTP is required'),
})
export const resetPasswordSchema = Yup.object({
  new_password: Yup.string().required('New Password is required'),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('new_password')], 'Passwords must match')
    .required('Confirm New Password is required'),
})

// PROFILE
export const updatePasswordSchema = Yup.object({
  currentPassword: Yup.string().required('Current Password is required'),
  newPassword: Yup.string().required('New Password is required'),
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .required('Confirm New Password is required'),
})
export const profileUpdateSchema = Yup.object({
  ...userCommonSchema,
})

// USERS
export const usersCreateSchema = Yup.object({
  ...userCommonSchema,
  role_id: Yup.string().required('Role is required'),
  society_id: Yup.string(), // .required('Society is required'),
  password: Yup.string().required('Password is required'),
})
export const usersUpdateSchema = Yup.object({
  ...userCommonSchema,
  role_id: Yup.string().required('Role is required'),
  society_id: Yup.string(), // .required('Society is required'),
  password: Yup.string(),
})

// GUARDS
export const guardsCreateSchema = Yup.object({
  ...userCommonSchema,
  email: Yup.string().required('User Name is required'),
  role_id: Yup.string().required('Role is required'),
  society_id: Yup.string(), // .required('Society is required'),
  password: Yup.string().required('Password is required'),
})
export const guardsUpdateSchema = Yup.object({
  ...userCommonSchema,
  email: Yup.string().required('User Name is required'),
  role_id: Yup.string().required('Role is required'),
  society_id: Yup.string(), // .required('Society is required'),
  password: Yup.string(),
})

// SOCIETIES
export const societiesFormSchema = Yup.object({
  society_name: Yup.string().required('Name is required'),
  email: Yup.string().email('Wrong email format').required('Email is required'),
  phone: Yup.string().required('Phone is required'),
  amount: Yup.number().required('Amount is required'),
  duration: Yup.string().required('Duration is required'),
  payment_method: Yup.string().required('Payment Method is required'),
  status: Yup.bool().oneOf([true, false], 'Status is required'),
  address: Yup.string().required('Address is required'),
})

export const updateScocitiesFormSchema = Yup.object({
  society_name: Yup.string().required('Name is required'),
  email: Yup.string().email('Wrong email format').required('Email is required'),
  phone: Yup.string().required('Phone is required'),
  amount: Yup.number().required('Amount is required'),
  duration: Yup.string().required('Duration is required'),
  payment_method: Yup.string().required('Payment Method is required'),
  status: Yup.bool().oneOf([true, false], 'Status is required'),
  start_date: Yup.string().required('Start Date is required'),
  end_date: Yup.string().required('End Date is required'),
})

// ANNOUNCEMENTS
export const announcementsFormSchema = Yup.object({
  title: Yup.string().required('Title is required'),
  text: Yup.string().required('Text is required'),
  postingDateTime: Yup.string().required('Posting date & time is required'),
  expiredDateTime: Yup.string().required('Expiry date & time is required'),

  attachment: Yup.mixed().nullable(),
})

// FAMILY MEMBERS
export const familyMembersFormSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  cnic: Yup.string().test(cnic_validator),
  phone: Yup.string(),
  gender: Yup.string().required('Gender is required'),
  dob: Yup.date().nullable(true), //.required('DOB is required'),
})

// VEHICLES
export const vehiclesFormSchema = Yup.object({
  vehicle_number: Yup.string().required('Vehicle number is required'),
  vehicle_description: Yup.string().required('Description is required'),
})

// EMERGENCY CONTACTS
export const emergencyContactsFormSchema = Yup.object({
  contact_name: Yup.string().required('Name is required'),
  contact_number: Yup.string().required('Number is required'),
})

// EMAIL TO USER
export const emailToUserFormSchema = Yup.object({
  subject: Yup.string().required('Subject is required'),
  text: Yup.string().required('Text is required'),
})

// NOTIFICATION TO USER
export const notificationToUserFormSchema = Yup.object({
  title: Yup.string().required('Title is required'),
  text: Yup.string().required('Text is required'),
})

// REJECT USER
export const rejectUserFormSchema = Yup.object({
  reason: Yup.string().required('Reason is required'),
})

// INVOICES
export const invoicesFormSchema = Yup.object({
  invoice_date: Yup.date().required('Invoice date is required'),
  due_date: Yup.date().required('Due date is required'),
  occupant: Yup.object().required('Please select a valid occupant.'),
  monthly_charges: Yup.number().required('Monthly recurring charges required.'),
  invoice_details: Yup.array().of(
    Yup.object().shape({
      description: Yup.string().required('Description is required.'),
      amount: Yup.number().required('Amount is required.'),
    })
  ),
  fine: Yup.number(),
  total_amount: Yup.number(),
  // paid_amount: Yup.number().max(
  //   Yup.ref('total_amount'),
  //   "Paid amount can't be grater than total payable."
  // ),
  paid_amount: Yup.number(),
  status: Yup.number().required('Status is required.'),
})

// Complaints
export const complaintsFormSchema = Yup.object({
  user_id: Yup.string().required('Please select a valid assignee.'),
})
export const complaintReplyFormSchema = Yup.object({
  assignee_reply: Yup.string().required('Reply is required.'),
})

// Ads
export const adsFormSchema = Yup.object({
  title: Yup.string().required('Title is required.'),
  description: Yup.string().required('Description is required.'),
  price: Yup.number().required('Price is required.'),
  status: Yup.number().required('Status is required.'),
})

// Brands
export const brandAdsFormSchema = Yup.object({
  brand_id: Yup.number().required('Brand name is required.'),
  text_ad: Yup.string().required('Description is required.'),
  link: Yup.string().required('Link is required.'),
  start_date: Yup.date().required('Start date is required.'),
  end_date: Yup.date().required('End date is required.'),
  // publish: Yup.number().required('Publish is required.'),
})
// Brands
export const brandsFormSchema = Yup.object({
  name: Yup.string().required('Brand name is required.'),
  email: Yup.string().email('Wrong email format').required('Email is required'),
  description: Yup.string().required('Description is required.'),
})

// surveysFormSchema

export const surveysFormSchema = Yup.object({
  title: Yup.string().required('Title is required.'),
  start_date: Yup.date().required('Start date is required').typeError('Invalid date'),
  end_date: Yup.date()
    .required('End date is required')
    .typeError('Invalid date')
    .min(Yup.ref('start_date'), 'End date must be after start date'),
  timer_hour: Yup.number()
    .min(0, 'Hour must be at least 0')
    .max(23, 'Hour cannot be more than 23')
    .required('Hour is required'),

  timer_minute: Yup.number()
    .min(0, 'Minute must be at least 0')
    .max(59, 'Minute cannot be more than 59')
    .required('Minute is required'),

  timer_second: Yup.number()
    .min(0, 'Second must be at least 0')
    .max(59, 'Second cannot be more than 59')
    .required('Second is required'),

  // 👇 Custom test to block 00:00:00
  time_limit_check: Yup.mixed().test(
    'non-zero-time',
    'Time limit must be greater than 00:00:00',
    function (_, context) {
      const {timer_hour, timer_minute, timer_second} = context.parent
      return timer_hour > 0 || timer_minute > 0 || timer_second > 0
    }
  ),
})

export const TicketsFormSchema = Yup.object({
  title: Yup.string().required('Title is required.'),
  description: Yup.string().required('Description is required.'),
})

//ServiceCategoriesForm

export const ServiceCategoriesFormSchema = Yup.object({
  title: Yup.string().required('Title is required.'),
})
//Service

// export const ServiceFormSchema = Yup.object({

//   title: Yup.string().required('Title is required.'),
//   description: Yup.string().required('Description is required.'),
//   price: Yup.number().required('Price is required.'),
//   status: Yup.number().required('Status is required.'),
//   // service_category_id: Yup.string().required('Service Category is required.'),
//   service_category_id: Yup.number().required('Service Category is required.'),
// // Conditional validation for vendor_id, only required for Super Admin (role_id === 1)
// vendor_id: Yup.mixed().when('auth.user.role_id', {
//   is: 1, // Checks if role_id is 1 (Super Admin)
//   then: Yup.number().required('Vendor is required for Super Admin.'),
//   otherwise: Yup.mixed().notRequired() // Not required for other users
// }),

// })

export const ServiceFormSchema = (role_id) => {
  const baseSchema = {
    title: Yup.string().required('Title is required.'),
    description: Yup.string().required('Description is required.'),
    price: Yup.number().required('Price is required.'),
    status: Yup.number().required('Status is required.'),
    service_category_id: Yup.number().required('Service Category is required.'),
  }

  if (role_id === 1) {
    baseSchema.vendor_id = Yup.number().required('Vendor is required')
  }

  return Yup.object().shape(baseSchema)
}

export const VendorFormSchema = Yup.object({
  Booking_status: Yup.string().required('Status is required.'),
})
